package meineglasfaser.api

import kotlinx.serialization.Serializable

enum class AdminUserRole {
    SYSTEM,
    ADMIN,
    EXTERNAL_LAHO,
}

@Serializable
data class AdminUserPrincipal(
    val id: String,
    val accountEmail: String,
    val accountPassword: String?,
    val roles: Set<AdminUserRole>,
)
